import { Tag } from "antd";
import {
  E_ORDER_STATUS,
  E_PAYMENT_STATUS,
  OrderStatusLabels,
  OrderStatusTagColor,
  PaymentStatusLabels,
  PaymentStatusTagColor,
} from "constants/common";
import { IOrder, IOrderItems } from "types/order";
import { formatDateTime } from "utils/datetime";

interface MobileOrderHistoryItemProps {
  order: IOrder;
  onClick?: () => void;
}

const MobileOrderHistoryItem = ({
  order,
  onClick,
}: MobileOrderHistoryItemProps) => {
  return (
    <div
      className="mb-4 p-4 bg-white rounded-lg shadow-sm cursor-pointer"
      onClick={onClick}
    >
      <div className="flex justify-between mb-2">
        <div className="font-medium">หมายเลขคำสั่งซื้อ #{order.id}</div>
        <div className="text-sm text-gray-500 text-end">
          {formatDateTime(order.orderDate)}
        </div>
      </div>

      <div className="flex justify-between mb-2">
        <div className="text-sm">จำนวนรายการสินค้า</div>
        <div className="font-medium">
          {(order.orderItems as IOrderItems[]).length} รายการ
        </div>
      </div>

      <div className="flex justify-between mb-2">
        <div className="text-sm">ราคารวม</div>
        <div className="font-semibold text-primary">
          ฿{order.totalAmount.toLocaleString()}
        </div>
      </div>

      <div className="flex justify-between mb-3">
        <div className="text-sm">คะแนนที่ใช้เป็นเงินสด</div>
        <div className="font-medium">
          {(() => {
            const orderLevelPoints = order.pointsAsCashUsed || 0;
            const itemLevelPoints = (order.orderItems as IOrderItems[]).reduce(
              (total, item) => total + item.pointsUsed,
              0
            );
            const pointsToShow =
              orderLevelPoints > 0 ? orderLevelPoints : itemLevelPoints;
            return pointsToShow > 0
              ? `${pointsToShow.toLocaleString()} คะแนน`
              : "-";
          })()}
        </div>
      </div>

      <div className="flex flex-wrap gap-2">
        <Tag color={OrderStatusTagColor[order.status as E_ORDER_STATUS]}>
          {OrderStatusLabels[order.status as E_ORDER_STATUS]}
        </Tag>

        <Tag
          color={PaymentStatusTagColor[order.paymentStatus as E_PAYMENT_STATUS]}
        >
          {PaymentStatusLabels[order.paymentStatus as E_PAYMENT_STATUS]}
        </Tag>
      </div>
    </div>
  );
};

export default MobileOrderHistoryItem;
